import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getPersonalInfo, getNavigationLabels } from '../utils/contentLoader';

function Header() {
  const personalInfo = getPersonalInfo();
  const navLabels = getNavigationLabels();
  const location = useLocation();
  
  // Check if current path is publications or a publication detail page
  const isPublicationsActive = location.pathname === '/publications' || 
                              location.pathname.startsWith('/publications/');
  
  return (
    <header className="site-header">
      <div className="container">
        <div className="header-content">
          <div className="site-branding">
            <Link to="/" className="site-title">{personalInfo.name || 'Personal Website'}</Link>
            {/* Removed the "Researcher & Engineer" title as requested */}
          </div>
          
          <nav className="site-navigation">
            <ul className="nav-menu">
              <li><Link to="/" className={location.pathname === '/' ? 'active' : ''} style={{ fontWeight: 'bold' }}>{navLabels.home || 'Home'}</Link></li>
              <li><Link to="/resume" className={location.pathname === '/resume' ? 'active' : ''} style={{ fontWeight: 'bold' }}>{navLabels.resume || 'Résumé'}</Link></li>
              <li><Link to="/publications" className={isPublicationsActive ? 'active' : ''} style={{ fontWeight: 'bold' }}>{navLabels.publications || 'Publications'}</Link></li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
